export const CREATE_USER_ACCOUNT = 'CREATE_USER_ACCOUNT'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const VERIFICATION = 'VERIFICATION'
export const API = 'API'
export const API_START = 'API_START'
export const API_END = 'API_END'
export const API_SUCCESS = 'API_SUCCESS'
export const PRODUCT_SUBSCRIBE = 'PRODUCT_SUBSCRIBE'
export const PRODUCT_SUBSCRIBE_DETAILS = 'PRODUCT_SUBSCRIBE_DETAILS'
export const PRODUCT_VERIFY_TOKEN = 'PRODUCT_VERIFY_TOKEN'
export const ACCESS_DENIED = 'ACCESS_DENIED'
export const API_ERROR = 'API_ERROR'
export const LOGOUT = 'LOGOUT'
export const RESEND_VERIFICATION = 'RESEND_VERIFICATION'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_PASSWORD_VERIFICATION = 'RESET_PASSWORD_VERIFICATION'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'

export const VERIFY_DOMAIN = 'VERIFY_DOMAIN'
export const CHANGE_EMAIL = 'CHANGE_EMAIL'
export const FORGOT_DOMAIN = 'FORGOT_DOMAIN'
export const LOGGED_OUT = 'LOGGED_OUT'
export const ADD_NEW_INVITEE = 'ADD_NEW_INVITEE'
export const NEW_PASSWORD_EMAIL = 'NEW_PASSWORD_EMAIL'
export const ADD_INBOX = 'ADD_INBOX'
export const ADD_GMAIL_INBOX = 'ADD_GMAIL_INBOX'
export const ASSIGN_INBOX = 'ASSIGN_INBOX'
export const GET_ALL_MAIL_INBOX = 'GET_ALL_MAIL_INBOX'
export const DELETE_INBOX = 'DELETE_INBOX'
export const UPDATE_INBOX = 'UPDATE_INBOX'
export const SEND_VERIFICATION_MAIL_INBOX = 'SEND_VERIFICATION_MAIL_INBOX'
export const SET_METADATA = 'SET_METADATA'
export const GET_META_DATA = 'GET_META_DATA'
export const GET_MAIL_BOX = 'GET_MAIL_BOX'
export const UPDATE_SMTP_SETTINGS = 'UPDATE_SMTP_SETTINGS'
export const RESEND_INVITATION = 'RESEND_INVITATION'
export const DELETE_INVITATION = 'DELETE_INVITATION'
export const GET_VERIFICATION = 'GET_VERIFICATION'
export const SET_PASSWORD = 'SET_PASSWORD'
export const GET_CONVERSATION_DATA = 'GET_CONVERSATION_DATA'
export const GET_SERACHED_CONVERSATION_DATA = 'GET_SERACHED_CONVERSATION_DATA'
export const SEND_MAIL = ' SEND_MAIL'
export const GET_CONVERSATION = 'GET_CONVERSATION'
export const PUT_CONVERSATION = 'PUT_CONVERSATION'
export const ADD_MESSAGE_TO_CONVERSATION = 'ADD_MESSAGE_TO_CONVERSATION'
export const SEND_NOTE = 'SEND_NOTE'
export const MOVE_CONVERSATION_TO = 'MOVE_CONVERSATION_TO'
export const DELETE_CONVERSATION = 'DELETE_CONVERSATION'
export const CLEAR_CONVERSATION = 'CLEAR_CONVERSATION'
export const SNOOZE_CONVERSATION = 'SNOOZE_CONVERSATION'
export const UPDATE_CONVERSATION_AND_REFRESH = 'UPDATE_CONVERSATION_AND_REFRESH'
export const DELETE_MSG_OF_CONVERSATION = 'DELETE_MSG_OF_CONVERSATION'
export const MERGE_CONVERSATION = 'MERGE_CONVERSATION'
export const SPLIT_CONVERSATION = 'SPLIT_CONVERSATION'
export const GET_ARTICLES_BY_CONVERSATION = 'GET_ARTICLES_BY_CONVERSATION'
export const ATTACHMENT_POST = 'ATTACHMENT_POST'
export const GET_CONTACT_LIST = 'GET_CONTACT_LIST'
export const GET_CONTACT_DETAILS = 'GET_CONTACT_DETAILS'
export const DELETE_CONTACT = 'DELETE_CONTACT'
export const SEARCH_CONTACT = 'SEARCH_CONTACT'
export const NEW_CONTACT = 'NEW_CONTACT'
export const CREATE_KNOWLEDGEBASE = 'CREATE_KNOWLEDGEBASE'
export const GET_KNOWLEDGEBASE = 'GET_KNOWLEDGEBASE'
export const GET_CATEGORIES = 'GET_CATEGORIES'
export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const GET_ARTICLES_DOC = 'GET_ARTICLES_DOC'
export const GET_ARTICLES_CATEGORY = 'GET_ARTICLES_CATEGORY'
export const GET_CATEGORY_DETAILS = 'GET_CATEGORY_DETAILS'
export const GET_ARTICLE_DETAIL = 'GET_ARTICLE_DETAIL'
export const CREATE_ARTICLE = 'CREATE_ARTICLE'
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE'
export const DELETE_ARTICLE = 'DELETE_ARTICLE'
export const UPDATE_DOC_CSS_AND_JS = 'UPDATE_DOC_CSS_AND_JS'
export const CREATE_REDIRECT_RULES = 'CREATE_REDIRECT_RULES'
export const GET_REDIRECT_RULE = 'GET_REDIRECT_RULE'
export const UPDATE_REDIRECT_RULE = 'UPDATE_REDIRECT_RULE'
export const DELETE_REDIRECT_RULE = 'DELETE_REDIRECT_RULE'
export const IMPORT_KNOWLEDGEBASE = 'IMPORT_KNOWLEDGEBASE'
export const EXPORT_KNOWLEDGEBASE = 'EXPORT_KNOWLEDGEBASE'
export const CONTENT_FROM_EXTERNAL_KNOWLEDGEBASE = 'CONTENT_FROM_EXTERNAL_KNOWLEDGEBASE'
export const GET_EXPORT_DOC_DETAILS = 'GET_EXPORT_DOC_DETAILS'
export const EDIT_CONTACT = 'EDIT_CONTACT'
export const ADD_LABEL_CONTACT = 'ADD_LABEL_CONTACT'
export const ADD_NOTE_CONTACTS = 'ADD_NOTE_CONTACTS'
export const LIST_COMPANY_CONTACTS = 'LIST_COMPANY_CONTACTS'
export const GET_ALL_COMPANIES = 'GET_ALL_COMPANIES'
export const GET_ALL_COMPANIES_IDS = 'GET_ALL_COMPANIES_IDS'
export const NEW_COMPANY = 'NEW_COMPANY'
export const GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS'
export const EDIT_COMPANY = 'EDIT_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const ADD_NOTE_COMPANIES = 'ADD_NOTE_COMPANIES'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROFILE_PASSWORD = 'UPDATE_PROFILE_PASSWORD'
export const GET_USERS = 'GET_USERS'
export const DELETE_USER = 'DELETE_USER'
export const ALLOW_USER_ACCESS = 'ALLOW_USER_ACCESS'
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE'
export const GET_TEMPLATE = 'GET_TEMPLATE'
export const GET_SINGLE_TEMPLATE = 'GET_SINGLE_TEMPLATE'
export const EDIT_SINGLE_TEMPLATE = 'EDIT_SINGLE_TEMPLATE'
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE'
export const DELETE_TEMPLATE_ATTACHMENT = 'DELETE_TEMPLATE_ATTACHMENT'
export const CREATE_TAG = 'CREATE_TAG'
export const DELETE_TAG = 'DELETE_TAG'
export const GET_TAGS = 'GET_TAGS'
export const ADD_SURVEY = 'ADD_SURVEY'
export const GET_SURVEY = 'GET_SURVEY'
export const GET_SURVEY_LIST = 'GET_SURVEY_LIST'
export const EDIT_SURVEY = 'EDIT_SURVEY'
export const DELETE_SURVEY = 'DELETE_SURVEY'
export const ADD_SLA = 'ADD_SLA'
export const GET_SLA = 'GET_SLA'
export const GET_SLA_LIST = 'GET_SLA_LIST'
export const EDIT_SLA = 'EDIT_SLA'
export const EDIT_SLA_STATUS = 'EDIT_SLA_STATUS'
export const DELETE_SLA = 'DELETE_SLA'
export const GET_USER_TEMPLATES = 'GET_USER_TEMPLATES'
export const CREATE_TIMING_SCHEME = 'CREATE_TIMING_SCHEME'
export const GET_ALL_TIMING = 'GET_ALL_TIMING'
export const GET_TIMING_SCHEME = 'GET_TIMING_SCHEME'
export const EDIT_TIMING_SCHEME = 'EDIT_TIMING_SCHEME'
export const DELETE_TIMING_SCHEME = 'DELETE_TIMING_SCHEME'
export const CREATE_TICKET = 'CREATE_TICKET'

export const ATTACHMENT_CONTACTS = 'ATTACHMENT_CONTACTS'
export const GLOBAL_SEARCH = 'GLOBAL_SEARCH'
export const LEARN_MORE = 'LEARN_MORE'
export const GET_STATUS_LIST = 'GET_STATUS_LIST'
export const GET_USER_ROLES = 'GET_USER_ROLES'
export const INITIAL_DATA = 'INITIAL_DATA'

export const CREATE_ASSETS_CATEGORY = 'CREATE_ASSETS_CATEGORY'
export const GET_ASSETS_CATEGORY = 'GET_ASSETS_CATEGORY'
export const GET_ASSETS_CATEGORY_WITH_FIELD = 'GET_ASSETS_CATEGORY_WITH_FIELD'
export const EDIT_ASSETS_CATEGORY = 'EDIT_ASSETS_CATEGORY'
export const DELETE_ASSETS_CATEGORY = 'DELETE_ASSETS_CATEGORY'

export const CREATE_ASSETS_STATUS = 'CREATE_ASSETS_STATUS'
export const GET_ASSETS_STATUS = 'GET_ASSETS_STATUS'
export const EDIT_ASSETS_STATUS = 'EDIT_ASSETS_STATUS'
export const DELETE_ASSETS_STATUS = 'DELETE_ASSETS_STATUS'

export const CREATE_ASSETS_FIELD = 'CREATE_ASSETS_FIELD'
export const GET_ASSETS_FIELD = 'GET_ASSETS_FIELD'
export const GET_SINGLE_ASSETS_FIELD = 'GET_SINGLE_ASSETS_FIELD'
export const EDIT_ASSETS_FIELD = 'EDIT_ASSETS_FIELD'
export const DELETE_ASSETS_FIELD = 'DELETE_ASSETS_FIELD'

export const CREATE_ASSETS = 'CREATE_ASSETS'
export const GET_ASSETS = 'GET_ASSETS'
export const GET_SINGLE_ASSETS = 'GET_SINGLE_ASSETS'
export const EDIT_ASSETS = 'EDIT_ASSETS'
export const DELETE_ASSETS = 'DELETE_ASSETS'

export const GET_FEEDBACK_FORM = 'GET_FEEDBACK_FORM'
export const EDIT_FEEDBACK_FORM = 'EDIT_FEEDBACK_FORM'
export const CREATE_FEEDBACK_FORM = 'CREATE_FEEDBACK_FORM'
export const DELETE_FEEDBACK_FORM = 'DELETE_FEEDBACK_FORM'
export const SINGLE_FEEDBACK_FORM = 'SINGLE_FEEDBACK_FORM'
export const EDIT_STATUS_FORM = 'EDIT_STATUS_FORM'

export const EDIT_FORM_WIDGET = 'EDIT_FORM_WIDGET'

export const GET_WIDGET = 'GET_WIDGET'
export const EDIT_WIDGET = 'EDIT_WIDGET'

export const GET_ALL_RULES = 'GET_ALL_RULES'
export const GET_RULE = 'GET_RULE'
export const EDIT_RULE = 'EDIT_RULE'
export const DELETE_RULE = 'DELETE_RULE'
export const CREATE_RULE = 'CREATE_RULE'

export const CREATE_ROUTING = 'CREATE_ROUTING'
export const GET_ROUTING = 'GET_ROUTING'
export const GET_ROUTING_DATA = 'GET_ROUTING_DATA'
export const DELETE_ROUTING = 'DELETE_ROUTING'
export const UPDATE_ROUTING = 'UPDATE_ROUTING'

export const INBOX_COUNTS = 'INBOX_COUNTS'

// Savan
export const GET_DOC_DETAILS = 'GET_DOC_DETAILS'
export const UPDATE_DOC_DETAILS = 'UPDATE_DOC_DETAILS'

export const UPDATE_DOC_SETTINGS = 'UPDATE_DOC_SETTINGS'
export const DELETE_KB = 'DELETE_KB'

export const INFLOW_BY_CHANNEL = 'INFLOW_BY_CHANNEL'
export const CHANNEL_DISTRIBUTION = 'CHANNEL_DISTRIBUTION'
export const INFLOW_ACROSS_TIME = 'INFLOW_ACROSS_TIME'
export const USER_ACITIVITIES_TIME = 'USER_ACITIVITIES_TIME'

export const TOTAL_CONVERSATION = 'TOTAL_CONVERSATION'
export const AVERAGE_FIRST_RESPONSE = 'AVERAGE_FIRST_RESPONSE'
export const AVERAGE_RESOLUTION = 'AVERAGE_RESOLUTION'
export const PRIORITY_ACROSS_TIME = 'PRIORITY_ACROSS_TIME'
export const FIRST_RESPONSE_TIME_STATS = 'FIRST_RESPONSE_TIME_STATS'
export const NEW_CONTACTS_ANALYTICS = 'NEW_CONTACTS_ANALYTICS'
export const AVERAGE_REPLIES_RESOLUTION = 'AVERAGE_REPLIES_RESOLUTION'
export const AVERAGE_RESOLUTION_TIME_STATS = 'AVERAGE_RESOLUTION_TIME_STATS'

export const TOTAL_RESOLVED = 'TOTAL_RESOLVED'
export const TOTAL_ASSIGNED = 'TOTAL_ASSIGNED'
export const FIRST_RESPONSE_USERS = 'FIRST_RESPONSE_USERS'
export const AVERAGE_RESOLUTION_USERS = 'AVERAGE_RESOLUTION_USERS'
export const ASSIGNED_VS_RESOLVED = ' ASSIGNED_VS_RESOLVED'
export const STATUS_ACROSS_TIME_USERS = ' STATUS_ACROSS_TIME_USERS'
export const AVERAGE_FIRST_RESPONSE_USERS = ' AVERAGE_FIRST_RESPONSE_USERS'
export const AVERAGE_RESOLVED_TIME_USERS = ' AVERAGE_RESOLVED_TIME_USERS'
export const OPEN_CONVERSATION_INBOX_STATUS = 'OPEN_CONVERSATION_INBOX_STATUS'
export const AVERAGE_REPLIES_RESOLUTION_USERS = ' AVERAGE_REPLIES_RESOLUTION_USERS'
export const OPEN_CONVERSATION_TIMETRACKING_PERCENTAGE = 'OPEN_CONVERSATION_TIMETRACKING_PERCENTAGE'
export const OPEN_CONVERSATION_TIMETRACKING_USERDATA = 'OPEN_CONVERSATION_TIMETRACKING_USERDATA'
export const CONVERSATION_STATS = 'CONVERSATION_STATS'
export const HOME_USERS_ANALYTICS = 'HOME_USERS_ANALYTICS'

export const METRIX_FIRST_RESPONSE_BREAKDOWN_ANALYTICS = 'METRIX_FIRST_RESPONSE_BREAKDOWN_ANALYTICS'
export const METRIX_RESOLUTION_BREAKDOWN_ANALYTICS = 'METRIX_RESOLUTION_BREAKDOWN_ANALYTICS'

export const FIRST_RESPONSE_TIME_SLA = 'FIRST_RESPONSE_TIME_SLA'
export const AVERAGE_RESOLUTION_TIME_SLA = 'AVERAGE_RESOLUTION_TIME_SLA'
export const RESOLVE_TARGET_OVER_TIME_SLA = 'RESOLVE_TARGET_OVER_TIME_SLA'
export const RESPONSE_TARGET_OVER_TIME_SLA = 'RESPONSE_TARGET_OVER_TIME_SLA'
export const USER_ACTIVITIES_TABLE_SLA = 'USER_ACTIVITIES_TABLE_SLA'
export const GET_SEARCHED_ARTICLES = 'GET_SEARCHED_ARTICLES'

export const TAGS_STATS = 'TAGS_STATS'
export const FIRST_CONTACT_RESOLVED = 'FIRST_CONTACT_RESOLVED'

export const NPS_SCORE_ANALYTICS = 'NPS_SCORE_ANALYTICS'
export const RATINGS_PERFORMANCE_ANALYTICS = 'RATINGS_PERFORMANCE_ANALYTICS'

export const TOTAL_VISITORS_ANALYTICS = 'TOTAL_VISITORS_ANALYTICS'
export const TOTAL_VIEWS_ANALYTICS = 'TOTAL_VIEWS_ANALYTICS'
export const TOTAL_ARTICLE_VIEWS = 'TOTAL_ARTICLE_VIEWS'
export const KB_PERFORMANCE_ANALYTICS = 'KB_PERFORMANCE_ANALYTICS'
export const MOST_POPULAR_PAGES = 'MOST_POPULAR_PAGES'
export const ARTICLE_RATINGS_ANALYTICS = 'ARTICLE_RATINGS_ANALYTICS'
export const CTR_STATS = 'CTR_STATS'

export const OPEN_CONVERSATION_INBOX = 'OPEN_CONVERSATION_INBOX'
export const OPEN_CONVERSATION_INBOX_PRIORITY = 'OPEN_CONVERSATION_INBOX_PRIORITY'
export const TOTAL_VISITORS_SEARCH = 'TOTAL_VISITORS_SEARCH'
export const SEARCH_ANALYTICS = 'SEARCH_ANALYTICS'
export const TOTAL_SEARCH_ANALYTICS = 'TOTAL_SEARCH_ANALYTICS'
export const CUST_SAT_CONVO = 'CUST_SAT_CONVO'
export const SUCCESSFUL_TERMS_TABLE = 'SUCCESSFUL_TERMS_TABLE'
export const FAILED_TERMS_TABLE = 'FAILED_TERMS_TABLE'

export const SUCCESS_VS_FAIL = 'SUCCESS_VS_FAIL'
export const CONVERSATION_STATUS_ANALYTICS = 'CONVERSATION_STATUS_ANALYTICS'

export const CREATE_CONTACT_FIELD = 'CREATE_CONTACT_FIELD'
export const EDIT_CONTACT_FIELD = 'EDIT_CONTACT_FIELD'
export const GET_ALL_CONTACT_FIELD = 'GET_ALL_CONTACT_FIELD'
export const GET_SINGLE_CONTACT_FIELD = 'GET_SINGLE_CONTACT_FIELD'
export const DELETE_CONTACT_FIELD = 'DELETE_CONTACT_FIELD'
export const GET_CONTACT_FIELD = 'GET_CONTACT_FIELD'

export const CREATE_TASK = 'CREATE_TASK'
export const GET_TASK = 'GET_TASK'
export const GET_ALL_TASK = 'GET_ALL_TASK'
export const DELETE_TASK = 'DELETE_TASK'
export const EDIT_TASK = 'EDIT_TASK'
export const CREATE_SUBTASK = 'CREATE_SUBTASK'
export const EDIT_SUBTASK = 'EDIT_SUBTASK'
export const DELETE_SUBTASK = 'DELETE_SUBTASK'

export const GET_TASK_OF_CONTACT = 'GET_TASK_OF_CONTACT'
export const UPDATE_WIDGET_LOGO = 'UPDATE_WIDGET_LOGO'
export const DELETE_WIDGET_LOGO = 'DELETE_WIDGET_LOGO'
export const ACTIVITIES_DATA = 'ACTIVITIES_DATA'

export const GET_CONTACT_LIST_ALL = 'GET_CONTACT_LIST_ALL'
export const GET_ALL_CONTACTS_IDS = 'GET_ALL_CONTACTS_IDS'
export const GET_TWITTER_CODE = 'GET_TWITTER_CODE'
export const GET_CHANNELS_ALL = 'GET_CHANNELS_ALL'
export const GET_CHANNEL = 'GET_CHANNEL'
export const EDIT_CHANNEL = 'EDIT_CHANNEL'
export const DELETE_CHANNEL = 'DELETE_CHANNEL'
export const ADD_WHATSAPP_CHANNEL = 'ADD_WHATSAPP_CHANNEL'
export const GET_TRAIL_LOGS = 'GET_TRAIL_LOGS'
export const GET_TRAIL_LOGS_KB = 'GET_TRAIL_LOGS_KB'

export const EDIT_USER = 'EDIT_USER'
export const GET_USER = 'GET_USER'
export const GET_TAGS_SETTING = 'GET_TAGS_SETTING'
export const EDIT_TAG_SETTING = 'EDIT_TAG_SETTING'

export const EDIT_TEAMS = 'EDIT_TEAMS'
export const GET_TEAM_DATA = 'GET_TEAM_DATA'
export const GET_TEAMS_LIST = 'GET_TEAMS_LIST'
export const DELETE_TEAMS = 'DELETE_TEAMS'
export const CREATE_TEAMS = 'CREATE_TEAMS'

export const GET_NOTIFICATION = 'GET_NOTIFICATION'
export const PUT_NOTIFICATION = 'PUT_NOTIFICATION'
export const MASS_ACTION = 'MASS_ACTION'

export const GET_USER_NOTIFICATION = 'GET_USER_NOTIFICATION'
export const APPEND_NOTIFICATION = 'APPEND_NOTIFICATION'
export const UPDATE_USER_NOTIFICATION = 'UPDATE_USER_NOTIFICATION'
export const SET_LIMIT = 'SET_LIMIT'

export const GET_GENERAL_SETTING = 'GET_GENERAL_SETTING'
export const UPDATE_GENERAL_SETTING = 'UPDATE_GENERAL_SETTING'

export const INVOICE_LISTING = 'INVOICE_LISTING'
export const GET_SINGLE_INVOICE = 'GET_SINGLE_INVOICE'
export const PAYMENT_METHOD = 'PAYMENT_METHOD'

export const TASK_BY_TYPES = 'TASK_BY_TYPES'
export const TASK_BY_STATUS = 'TASK_BY_STATUS'
export const TASK_TYPES_OVER_TIME = 'TASK_TYPES_OVER_TIME'
export const TASK_STATUS_OVER_TIME = 'TASK_STATUS_OVER_TIME'
export const TASK_BY_USERS = 'TASK_BY_USERS'

export const UPLOAD_LOGO_CATEGORY = 'UPLOAD_LOGO_CATEGORY'
export const UPLOAD_LOGO_ARTICLE = 'UPLOAD_LOGO_ARTICLE'
export const UPLOAD_IMAGE_CUSTOMIZATION = 'UPLOAD_IMAGE_CUSTOMIZATION'
export const UPLOAD_FAVICON_CUSTOMIZATION = 'UPLOAD_FAVICON_CUSTOMIZATION'
export const UPLOAD_LOGO_CUSTOMIZATION = 'UPLOAD_LOGO_CUSTOMIZATION'
export const RESTORE_ARTICLE_DATA = 'RESTORE_ARTICLE_DATA'

export const CREATE_TASK_NOTE = 'CREATE_TASK_NOTE'

export const GET_ALL_TASK_TEMPLATES = 'GET_ALL_TASK_TEMPLATES'
export const CREATE_TASK_TEMPLATE = 'CREATE_TASK_TEMPLATE'
export const EDIT_TASK_TEMPLATE = 'EDIT_TASK_TEMPLATE'
export const DELETE_TASK_TEMPLATE = 'DELETE_TASK_TEMPLATE '
export const GET_TASK_TEMPLATE = 'GET_TASK_TEMPLATE'

export const GET_ALL_TASK_AUTOMATIONS = 'GET_ALL_TASK_AUTOMATIONS'
export const CREATE_TASK_AUTOMATION = 'CREATE_TASK_AUTOMATION'
export const EDIT_TASK_AUTOMATION = 'EDIT_TASK_AUTOMATION'
export const DELETE_TASK_AUTOMATION = 'DELETE_TASK_AUTOMATION '
export const GET_TASK_AUTOMATION = 'GET_TASK_AUTOMATION'

export const IMPORT_ASSETS = 'IMPORT_ASSETS'
export const EXPORT_SAMPLE_ASSET_CSV = 'EXPORT_SAMPLE_ASSET_CSV'
export const ASSET_BY_CATEGORY = 'ASSET_BY_CATEGORY'
export const ASSET_BY_STATUS = 'ASSET_BY_STATUS'
export const ASSET_CATEGORY_OVER_TIME = 'ASSET_CATEGORY_OVER_TIME'
export const ASSET_STATUS_OVER_TIME = 'ASSET_STATUS_OVER_TIME'
export const TOTAL_ASSETS_AND_NEW_ASSETS = 'TOTAL_ASSETS_AND_NEW_ASSETS'
export const CREATE_ASSETS_COPY = 'CREATE_ASSETS_COPY'

export const GET_ALL_VERSIONS_ARTICLE = 'GET_ALL_VERSIONS_ARTICLE'
export const DELETE_VERSION = 'DELETE_VERSION'
export const ARTICLE_VERSION_COMPARE = 'ARTICLE_VERSION_COMPARE'
export const GET_ART_VERSION_DETAILS = 'GET_ART_VERSION_DETAILS'
export const ARTICLE_VERSION_PUBLISH = 'ARTICLE_VERSION_PUBLISH'
export const UPDATE_CATEGORY_REORDERING = 'UPDATE_CATEGORY_REORDERING'
export const UPDATE_ARTICLE_REORDERING = 'UPDATE_ARTICLE_REORDERING'

export const GET_API_KEY = 'GET_API_KEY'

export const GET_LIVECHAT = 'GET_LIVECHAT'
export const DELETE_LIVECHAT = 'DELETE_LIVECHAT'
export const INSTALL_LIVECHAT = 'INSTALL_LIVECHAT'
export const UPDATE_LIVECHAT = 'UPDATE_LIVECHAT'

export const GET_MAILBOX_SHOPIFY = 'GET_MAILBOX_SHOPIFY'
export const GET_CUSTOMER_DETAILS_SHOPIFY = 'GET_CUSTOMER_DETAILS_SHOPIFY'
export const GET_CUSTOMER_ORDER_SHOPIFY = 'GET_CUSTOMER_ORDER_SHOPIFY'
export const GET_SHOPIFY_SHOP_LIST = 'GET_SHOPIFY_SHOP_LIST'
export const EDIT_SHOPIFY_SHOP = 'EDIT_SHOPIFY_SHOP'
export const DELETE_SHOPIFY_SHOP = 'DELETE_SHOPIFY_SHOP'

export const GET_SHOPIFY_PRODUCT_LIST = 'GET_SHOPIFY_PRODUCT_LIST'
export const CREATE_DRAFT_ORDER = 'CREATE_DRAFT_ORDER'
export const UPDATE_DRAFT_ORDER = 'UPDATE_DRAFT_ORDER'
export const DELETE_DRAFT_ORDER = 'DELETE_DRAFT_ORDER'
export const GET_SHOPIFY_PAYMENT_TERMS = 'GET_SHOPIFY_PAYMENT_TERMS'
export const DRAFT_TO_COMPLETE_ORDER = 'DRAFT_TO_COMPLETE_ORDER'
export const CREATE_DUPLICATE_ORDER = 'CREATE_DUPLICATE_ORDER'
export const REFUND_SHOPIFY_ORDER = 'REFUND_SHOPIFY_ORDER'
export const CANCEL_SHOPIFY_ORDER = 'CANCEL_SHOPIFY_ORDER'

export const GET_BIGCOMMERCE_STORE_CUSTOMER_DETAILS = 'GET_BIGCOMMERCE_STORE_CUSTOMER_DETAILS'
export const GET_BIGCOMMERCE_PRODUCT_LIST = 'GET_BIGCOMMERCE_PRODUCT_LIST'
export const CREATE_CUSTOMER_ORDER = 'CREATE_CUSTOMER_ORDER'
export const GET_BIGCOMMERCE_CUSTOMER_ADDRESS = 'GET_BIGCOMMERCE_CUSTOMER_ADDRESS'
export const GET_BIGCOMMERCE_ORDER_LIST = 'GET_BIGCOMMERCE_ORDER_LIST'
export const BIGCOMMERCE_CALCULATE_REFUND = 'BIGCOMMERCE_CALCULATE_REFUND'
export const BIGCOMMERCE_CONFIRM_REFUND = 'BIGCOMMERCE_CONFIRM_REFUND'
export const GET_BIGCOMMERCE_SHOP_LIST = 'GET_BIGCOMMERCE_SHOP_LIST'
export const GET_MAILBOX_BIGCOMMERCE = 'GET_MAILBOX_BIGCOMMERCE'
export const EDIT_BIGCOMMERCE_SHOP = 'EDIT_BIGCOMMERCE_SHOP'
export const GET_SMS_CHANNEL_LIST = 'GET_SMS_CHANNEL_LIST'
export const GET_SMS_SINGLE = 'GET_SMS_SINGLE'
export const UPDATE_SMS = 'UPDATE_SMS'
export const DELETE_SMS = 'DELETE_SMS'
export const ADD_SMS_CHANNEL = 'ADD_SMS_CHANNEL'
export const GET_PHONE_NUMBER = 'GET_PHONE_NUMBER'
export const GET_SHARED_SECRET_KEY = 'GET_SHARED_SECRET_KEY'
export const GENERATE_OPEN_AI_MESSAGE = 'GENERATE_OPEN_AI_MESSAGE'
export const MODIFY_OPEN_AI_EMAIL_REPLY = 'MODIFY_OPEN_AI_EMAIL_REPLY'

export const ADD_JIRA = 'ADD_JIRA'
export const GET_JIRA = 'GET_JIRA'
export const UPDATE_JIRA = 'UPDATE_JIRA'
export const DELETE_JIRA = 'DELETE_JIRA'
export const GET_JIRA_ISSUES = 'GET_JIRA_ISSUES'
export const JIRA_LINK_ISSUE_WITH_CONVERSATION = 'JIRA_LINK_ISSUE_WITH_CONVERSATION'
export const GET_JIRA_CONVERSATION_ISSUES = 'GET_JIRA_CONVERSATION_ISSUES'
export const JIRA_UNLINK_ISSUE_WITH_CONVERSATION = 'JIRA_UNLINK_ISSUE_WITH_CONVERSATION'
export const GET_JIRA_PROJECT_ISSUES_TYPES = 'GET_JIRA_PROJECT_ISSUES_TYPES'
export const GET_JIRA_USERS_LIST = 'GET_JIRA_USERS_LIST'
export const CREATE_JIRA_ISSUE_AND_LINK = 'CREATE_JIRA_ISSUE_AND_LINK'

export const GET_GITHUB = 'GET_GITHUB'
export const UPDATE_GITHUB = 'UPDATE_GITHUB'
export const STATE_GITHUB = 'STATE_GITHUB'
export const GET_GITHUB_CONVERSATION_ISSUES = 'GET_GITHUB_CONVERSATION_ISSUES'
export const GET_GITHUB_REPOS = 'GET_GITHUB_REPOS'
export const GET_GITHUB_MILESTONES = 'GET_GITHUB_MILESTONES'
export const GET_GITHUB_LABELS = 'GET_GITHUB_LABELS'
export const GET_GITHUB_COLLABORATORS = 'GET_GITHUB_COLLABORATORS'
export const CREATE_GITHUB_ISSUE_AND_LINK = 'CREATE_GITHUB_ISSUE_AND_LINK'
export const GET_GITHUB_ISSUES_FOR_REPO = 'GET_GITHUB_ISSUES_FOR_REPO'
export const GET_GITHUB_LINKED_ISSUE = 'GET_GITHUB_LINKED_ISSUE'
export const GITHUB_LINK_EXISTING_ISSUES = 'GITHUB_LINK_EXISTING_ISSUES'
export const GITHUB_UNLINK_ISSUE = 'GITHUB_UNLINK_ISSUE'
export const GITHUB_CHANGE_STATE_ISSUE = 'GITHUB_CHANGE_STATE_ISSUE'
export const DELETE_GITHUB = 'DELETE_GITHUB'

export const INTEGRATE_ASANA = 'INTEGRATE_ASANA'
export const INSTALL_ASANA = 'INSTALL_ASANA'
export const GET_ASANA = 'GET_ASANA'
export const UPDATE_ASANA = 'UPDATE_ASANA'
export const CREATE_ASANA_TASK_AND_LINK = 'CREATE_ASANA_TASK_AND_LINK'
export const GET_ASANA_WORKSPACES = 'GET_ASANA_WORKSPACES'
export const GET_ASANA_ASSIGNEES = 'GET_ASANA_ASSIGNEES'
export const GET_ASANA_TAGS = 'GET_ASANA_TAGS'
export const GET_ASANA_PROJECTS = 'GET_ASANA_PROJECTS'
export const GET_ASANA_TASK_FOR_PROJECT = 'GET_ASANA_TASK_FOR_PROJECT'
export const GET_ASANA_TASK_DETAILS = 'GET_ASANA_TASK_DETAILS'
export const GET_ASANA_LINK_EXISTING = 'GET_ASANA_LINK_EXISTING'
export const GET_LINKED_ASANA_TASKS = 'GET_LINKED_ASANA_TASKS'
export const ASANA_UNLINK_TASK = 'ASANA_UNLINK_TASK'
export const DELETE_ASANA = 'DELETE_ASANA'

export const DELETE_CLICKUP = 'DELETE_CLICKUP'
export const UPDATE_CLICKUP = 'UPDATE_CLICKUP'
export const GET_CLICKUP = 'GET_CLICKUP'
export const INSTALL_CLICKUP = 'INSTALL_CLICKUP'
export const GET_CLICKUP_WORKSPACES = 'GET_CLICKUP_WORKSPACES'
export const GET_CLICKUP_SPACES = 'GET_CLICKUP_SPACES'
export const GET_CLICKUP_FOLDERS_WITHIN_SPACE = 'GET_CLICKUP_FOLDERS_WITHIN_SPACE'
export const GET_CLICKUP_LIST_WITHIN_SPACE = 'GET_CLICKUP_LIST_WITHIN_SPACE'

export const GET_CLICKUP_TASKS_FROM_LIST = 'GET_CLICKUP_TASKS_FROM_LIST'
export const GET_CLICKUP_TAGS = 'GET_CLICKUP_TAGS'
export const CLICKUP_CREATE_TASK = 'CLICKUP_CREATE_TASK'
export const CLICKUP_LINK_TASK = 'CLICKUP_LINK_TASK'
export const GET_CLICKUP_LINKED_TASKS = 'GET_CLICKUP_LINKED_TASKS'
export const CLICKUP_UNLINK_TASK = 'CLICKUP_UNLINK_TASK'

export const GET_TRELLO = 'GET_TRELLO'
export const UPDATE_TRELLO = 'UPDATE_TRELLO'
export const INSTALL_TRELLO = 'INSTALL_TRELLO'
export const DELETE_TRELLO = 'DELETE_TRELLO'
export const TRELLO_UNLINK_CARD = 'TRELLO_UNLINK_CARD'
export const GET_TRELLO_LINKED_CARDS = 'GET_TRELLO_LINKED_CARDS'
export const GET_TRELLO_BOARDS = 'GET_TRELLO_BOARDS'
export const GET_TRELLO_LISTS = 'GET_TRELLO_LISTS'
export const GET_TRELLO_CARDS = 'GET_TRELLO_CARDS'
export const GET_TRELLO_LABELS = 'GET_TRELLO_LABELS'
export const GET_TRELLO_MEMBERS = 'GET_TRELLO_MEMBERS'
export const CREATE_TRELLO_CARD = 'CREATE_TRELLO_CARD'
export const TRELLO_LINK_EXISTING_CARD = 'TRELLO_LINK_EXISTING_CARD'

export const GET_ALL_ROLES = 'GET_ALL_ROLES'
export const GET_ROLE = 'GET_ROLE'
export const ADD_ROLE = 'ADD_ROLE'
export const UPDATE_ROLE = 'UPDATE_ROLE'
export const DELETE_ROLE = 'DELETE_ROLE'
export const GET_ROLES_STRUCTURE = 'GET_ROLES_STRUCTURE'
export const GET_USER_ROLE_PERMISSIONS = 'GET_USER_ROLE_PERMISSIONS'

export const GET_MAGENTO = 'GET_MAGENTO'
export const CREATE_MAGENTO = 'CREATE_MAGENTO'
export const UPDATE_MAGENTO = 'UPDATE_MAGENTO'
export const DELETE_MAGENTO = 'DELETE_MAGENTO'
export const GET_MAGENTO_ORDERS = 'GET_MAGENTO_ORDERS'
export const LINK_ORDER_MAGENTO = 'LINK_ORDER_MAGENTO'
export const CANCEL_ORDER_MAGENTO = 'CANCEL_ORDER_MAGENTO'
export const REFUND_ORDER_MAGENTO = 'REFUND_ORDER_MAGENTO'
export const GET_LINKED_ORDERS = 'GET_LINKED_ORDERS'

export const DELETE_SLACK = 'DELETE_SLACK'
export const GET_SLACK = 'GET_SLACK'
export const INSTALL_SLACK = 'INSTALL_SLACK'
export const UPDATE_SLACK = 'UPDATE_SLACK'

export const CURRENT_SUBSCRIPTION = 'CURRENT_SUBSCRIPTION'
export const GET_PAYMENT_METHOD = 'GET_PAYMENT_METHOD'
export const CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD'
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD'
export const DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD'

export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS'
export const GET_BILLING_ADDRESS = 'GET_BILLING_ADDRESS'

export const GET_DESK_PLANS = 'GET_DESK_PLANS'
export const START_BILLING = 'START_BILLING'
export const UPDATE_BILLING = 'UPDATE_BILLING'
export const CANCEL_BILLING = 'CANCEL_BILLING'
export const RESUME_BILLING = 'RESUME_BILLING'
export const CALCULATE_BILLING = 'CALCULATE_BILLING'
export const REFRESH_ACCESS_TOKEN = 'REFRESH_ACCESS_TOKEN'

export const DELETE_INTERCOM = 'DELETE_INTERCOM'
export const GET_INTERCOM = 'GET_INTERCOM'
export const INSTALL_INTERCOM = 'INSTALL_INTERCOM'
export const UPDATE_INTERCOM = 'UPDATE_SLACK'

export const DELETE_DRIFT = 'DELETE_DRIFT'
export const GET_DRIFT = 'GET_DRIFT'
export const INSTALL_DRIFT = 'INSTALL_DRIFT'
export const UPDATE_DRIFT = 'UPDATE_DRIFT'
export const GET_DRIFT_CONTACT = 'GET_DRIFT_CONTACT'

export const UPDATE_TIME_TRACKING = 'UPDATE_TIME_TRACKING'
export const GET_TIME_TRACKING = 'GET_TIME_TRACKING'
export const UPDATE_TIME_TRACKING_ENTRY = 'UPDATE_TIME_TRACKING_ENTRY'
export const SUBMIT_TIME_TRACKING_MANUAL = 'SUBMIT_TIME_TRACKING_MANUAL'
export const SUBMIT_TIME_TRACKING_AUTOMATIC = 'SUBMIT_TIME_TRACKING_AUTOMATIC'
export const GET_TIME_TRACKING_ENTRY_STATUS = 'GET_TIME_TRACKING_ENTRY_STATUS'

export const GET_ENTERIES_CONVERSATION = 'GET_ENTERIES_CONVERSATION'
export const DELETE_ENTRIES = 'DELETE_ENTRIES'
export const MANUAL_TASK_ENTERIES = 'MANUAL_TASK_ENTERIES'
export const DELETE_ENTERIES_TASK = 'DELETE_ENTERIES_TASK'
export const UPDATE_ENTERIES_TASK = 'UPDATE_ENTERIES_TASK'
export const GET_TIME_TRACKING_ENTRY_STATUS_TASK = 'GET_TIME_TRACKING_ENTRY_STATUS_TASK'
export const GET_ENTERIES_TASK = 'GET_ENTERIES_TASK'

export const ADD_SEGMENT = 'ADD_SEGMENT'
export const UPDATE_SEGMENT = 'UPDATE_SEGMENT'
export const DELETE_SEGMENT = 'DELETE_SEGMENT'
export const GET_SEGMENT = 'GET_SEGMENT'
export const GET_ALL_SEGMENT = 'GET_ALL_SEGMENT'
export const GET_STATIC_CONTACT = 'GET_STATIC_CONTACT'
export const GET_INTEGRATION_LIST = 'GET_INTEGRATION_LIST'

export const GET_ALL_COMPANY_SEGMENT = 'GET_ALL_COMPANY_SEGMENT'
export const GET_STATIC_COMPANY = 'GET_STATIC_COMPANY'
export const ADD_COMPANY_SEGMENT = 'ADD_COMPANY_SEGMENT'
export const UPDATE_COMPANY_SEGMENT = 'UPDATE_COMPANY_SEGMENT'
export const DELETE_COMPANY_SEGMENT = 'DELETE_COMPANY_SEGMENT'
export const GET_COMPANY_SEGMENT = 'GET_COMPANY_SEGMENT'
// Status Page Started

export const GET_ALL_INCIDENTS_SOURCE = 'GET_ALL_INCIDENTS_SOURCE'
export const ADD_INCIDENTS_SOURCE = 'ADD_INCIDENTS_SOURCE'
export const DELETE_INCIDENTS_SOURCE = 'DELETE_INCIDENTS_SOURCE'
export const UPDATE_INCIDENTS_SOURCE = 'UPDATE_INCIDENTS_SOURCE'

export const GET_ALL_INCIDENTS_STATUS = 'GET_ALL_INCIDENTS_STATUS'
export const ADD_INCIDENTS_STATUS = 'ADD_INCIDENTS_STATUS'
export const DELETE_INCIDENTS_STATUS = 'DELETE_INCIDENTS_STATUS'
export const UPDATE_INCIDENTS_STATUS = 'UPDATE_INCIDENTS_STATUS'

export const GET_ALL_SUBSCRIBER = 'GET_ALL_SUBSCRIBER'
export const TOGGEL_SUBSCRIBER_EMAIL = 'TOGGEL_SUBSCRIBER_EMAIL'
export const ADD_SUBSCRIBER = 'ADD_SUBSCRIBER'
export const DELETE_SUBSCRIBER = 'DELETE_SUBSCRIBER'
export const UPDATE_SUBSCRIBER = 'UPDATE_SUBSCRIBER'

export const GET_ALL_SERVICES = 'GET_ALL_SERVICES'
export const ADD_SERVICES_COMPO = 'ADD_SERVICES_COMPO'
export const GET_ALL_COMPO_GROUP = 'GET_ALL_COMPO_GROUP'
export const DELETE_SERVICES_COMPO = 'DELETE_SERVICES_COMPO'
export const GET_SINGLE_COMPO = 'GET_SINGLE_COMPO'
export const CLEAR_SINGLE_COMPO = 'CLEAR_SINGLE_COMPO'
export const UPDATE_SERVICES_COMPO = 'UPDATE_SERVICES_COMPO'

export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES'
export const DELETE_STATUS_TEMPLATES = 'DELETE_STATUS_TEMPLATES'
export const ADD_STATUS_TEMPLATES = 'ADD_STATUS_TEMPLATES'
export const UPDATE_STATUS_TEMPLATES = 'UPDATE_STATUS_TEMPLATES'
export const GET_SINGLE_TEMPLATES = 'GET_SINGLE_TEMPLATES'

export const GET_STATUS_EMBED = 'GET_STATUS_EMBED'
export const UPDATE_STATUS_EMBED = 'UPDATE_STATUS_EMBED'
export const GET_STATUS_GENERAL = 'GET_STATUS_GENERAL'
export const UPDATE_STATUS_GENERAL = 'UPDATE_STATUS_GENERAL'

export const GET_ALL_INCIDENTS = 'GET_ALL_INCIDENTS'
export const ADD_INCIDENTS = 'ADD_INCIDENTS'
export const DELETE_INCIDENTS = 'DELETE_INCIDENTS'
export const UPDATE_INCIDENTS = 'UPDATE_INCIDENTS'
export const GET_SINGLE_INCIDENTS = 'GET_SINGLE_INCIDENTS'

export const GET_ALL_MAINTAINANCE = 'GET_ALL_MAINTAINANCE'
export const ADD_MAINTAINANCE = 'ADD_MAINTAINANCE'
export const DELETE_MAINTAINANCE = 'DELETE_MAINTAINANCE'
export const UPDATE_MAINTAINANCE = 'UPDATE_MAINTAINANCE'
export const UPDATE_MAINTAINANCE_STATUS = 'UPDATE_MAINTAINANCE_STATUS'
export const GET_SINGLE_MAINTAINANCE = 'GET_SINGLE_MAINTAINANCE'

export const GET_PAGE_SETTINGS = 'GET_PAGE_SETTINGS'
export const UPDATE_PAGE_SETTINGS = 'UPDATE_PAGE_SETTINGS'
export const UPLOAD_LOGO_STATUS = 'UPLOAD_LOGO_STATUS'
export const DELETE_LOGO_STATUS = 'DELETE_LOGO_STATUS'
export const UPLOAD_FAVICON_STATUS = 'UPLOAD_FAVICON_STATUS'
export const DELETE_FAVICON_STATUS = 'DELETE_FAVICON_STATUS'

export const CREATE_STATUS_PAGE = 'CREATE_STATUS_PAGE'
export const DELETE_STATUS_PAGE = 'DELETE_STATUS_PAGE'

export const TOTAL_INCIDENT_STATS = 'TOTAL_INCIDENT_STATS'
export const MEAN_TIME_RESOLVE_INCIDENT = 'MEAN_TIME_RESOLVE_INCIDENT'
export const TOTAL_MAINTENANCES_STATS = 'TOTAL_MAINTENANCES_STATS'
export const MEAN_TIME_RESOLVE_MAINTENANCES = 'MEAN_TIME_RESOLVE_MAINTENANCES'
export const SERVICE_STATUS_CHART = 'SERVICE_STATUS_CHART'

// Status Page End

// analytics Staffing Prediction
export const STAFFING_PREDICTION_OVERTIME = 'STAFFING_PREDICTION_OVERTIME'

// Client portal
export const CREATE_CLIENT_PORTAL_ANNOUNCEMENT = 'CREATE_CLIENT_PORTAL_ANNOUNCEMENT'
export const GET_CLIENT_PORTAL_ANNOUNCEMENTS = 'GET_CLIENT_PORTAL_ANNOUNCEMENTS'
export const GET_CLIENT_PORTAL_SINGLE_ANNOUNCEMENT = 'GET_CLIENT_PORTAL_SINGLE_ANNOUNCEMENT'
export const UPDATE_CLIENT_PORTAL_ANNOUNCEMENT = 'UPDATE_CLIENT_PORTAL_ANNOUNCEMENT'
export const DELETE_CLIENT_PORTAL_ANNOUNCEMENT = 'DELETE_CLIENT_PORTAL_ANNOUNCEMENT'
export const GET_CLIENT_PORTAL_SETTINGS = 'GET_CLIENT_PORTAL_SETTINGS'
export const UPDATE_CLIENT_PORTAL_SETTINGS = 'UPDATE_CLIENT_PORTAL_SETTINGS'
export const UPLOAD_CLIENT_PORTAL_LOGO = 'UPLOAD_CLIENT_PORTAL_LOGO'
export const DELETE_CLIENT_PORTAL_LOGO = 'DELETE_CLIENT_PORTAL_LOGO'
export const GET_CLIENT_PORTAL_TICKET_FORM = 'GET_CLIENT_PORTAL_TICKET_FORM'
export const UPDATE_CLIENT_PORTAL_TICKET_FORM = 'UPDATE_CLIENT_PORTAL_TICKET_FORM'
export const CLEAR_SEGMENT_DATA = 'CLEAR_SEGMENT_DATA'

export const UPDATE_SELECTED_ASSIGNEE = 'UPDATE_SELECTED_ASSIGNEE'

export const UPDATE_SELECTED_KNOWLEDGEBASE = 'UPDATE_SELECTED_KNOWLEDGEBASE'
export const UPDATE_SELECTED_INBOX = 'UPDATE_SELECTED_INBOX'
